// Sfruttare CSS inline per pp.css

function ProtectedPage() {
    return <h1>Benvenuto nella pagina protetta!</h1>;
  }
  
  export default ProtectedPage;